<template>
  <div >
    <b-card
      class="wizard availtable datatable wizardcontent"
      no-body
      header-bg-variant="primary"
      footer-bg-variant="primary"
    >
      <div class="text-center" slot="header">
        <b-row><b-col>Import File Wizard</b-col></b-row>
        <b-row no-gutters>
          <b-col>
            <i class="fa fa-magic"></i>
            Choose a Data Source Step {{ displayStep }}
          </b-col>
        </b-row>
      </div>
      <div class="step-content p-4">
        <div v-if="currentStep == 1" class="step-pane active">
          <p>Select the source from which to copy data.</p>
          <b-row>
            <b-col cols="3"
              ><b-list-group>
                <b-list-group-item
                  ><i class="fa fa-file"></i> General</b-list-group-item
                >
                <b-list-group-item
                  ><i class="fa fa-file"></i> Columns</b-list-group-item
                >
                <b-list-group-item
                  ><i class="fa fa-file"></i> Advanced</b-list-group-item
                >
                <b-list-group-item
                  ><i class="fa fa-file"></i> Preview</b-list-group-item
                >
              </b-list-group></b-col
            >
            <b-col>
              <b-row>
                <b-col
                  >Select a file and specify the file properties and the file
                  format.</b-col
                >
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <b-form-group
                    label="File Name"
                    label-for="filename"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-form-input
                        type="text"
                        v-model="item.filename"
                        placeholder="Enter file name"
                        size="sm"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          @click="item.filename = ''"
                        >
                          <i class="fa fa-search pr-2"></i>Browse
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Locale"
                    label-for="locale"
                    label-cols="12"
                    label-size="sm"
                  >
                    <treeselect
                      instanceId="locale"
                      type="text"
                      v-model="item.locale"
                      :clearable="false"
                      :options="[
                        {
                          label: 'English (United Kingdom)',
                          id: 'English (United Kingdom)',
                        },
                      ]"
                    ></treeselect>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group
                    label="Unicode"
                    label-for="unicode"
                    label-cols="12"
                  >
                    <b-form-checkbox
                      id="unicode"
                      v-model="item.unicode"
                      class="z-0"
                    >
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Code Page"
                    label-for="codepage"
                    label-cols="12"
                    label-size="sm"
                  >
                    <treeselect
                      instanceId="codepage"
                      type="text"
                      v-model="item.codepage"
                      :clearable="false"
                      :options="[
                        {
                          label: '65001 (UTF-8)',
                          id: '65001 (UTF-8)',
                        },
                      ]"
                    ></treeselect>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Format"
                    label-for="format"
                    label-cols="12"
                    label-size="sm"
                  >
                    <treeselect
                      instanceId="format"
                      type="text"
                      v-model="item.format"
                      :clearable="false"
                      :options="[
                        {
                          label: 'Delimited',
                          id: 'Delimited',
                        },
                      ]"
                    ></treeselect>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <b-form-group
                    label="Text qualifier"
                    label-for="textqualifier"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-form-input
                        type="text"
                        v-model="item.textqualifier"
                        placeholder="<none>"
                        size="sm"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Header Row Delimiter"
                    label-for="headerdelimiter"
                    label-cols="12"
                    label-size="sm"
                  >
                    <treeselect
                      instanceId="headerdelimiter"
                      type="text"
                      v-model="item.headerdelimiter"
                      :clearable="false"
                      :options="[
                        {
                          label: '{CR}{LF}',
                          id: '{CR}{LF}',
                        },
                      ]"
                    ></treeselect>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <b-form-group
                    label="Header rows to skip"
                    label-for="headerrowstoskip"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-form-input
                        type="number"
                        v-model="item.headerrowstoskip"
                        placeholder="0"
                        size="sm"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-input-group>
                    <b-form-checkbox
                      id="columnnames"
                      v-model="item.columnnames"
                      class="z-0"
                    >
                    </b-form-checkbox>
                    <span>Column names in the first data row</span>
                  </b-input-group></b-col
                >
              </b-row>
            </b-col>
          </b-row>
        </div>

        <div v-if="currentStep == 2" class="step-pane active">
          <div>
            <p>Select the source from which to copy data.</p>
            <b-row>
              <b-col cols="3"
                ><b-list-group>
                  <b-list-group-item
                    ><i class="fa fa-file"></i> General</b-list-group-item
                  >
                  <b-list-group-item
                    ><i class="fa fa-file"></i> Columns</b-list-group-item
                  >
                  <b-list-group-item
                    ><i class="fa fa-file"></i> Advanced</b-list-group-item
                  >
                  <b-list-group-item
                    ><i class="fa fa-file"></i> Preview</b-list-group-item
                  >
                </b-list-group></b-col
              >
              <b-col>
                <b-row>
                  <b-col
                    >Specify the characters that delimit the source file.</b-col
                  >
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <b-form-group
                      label="Row Delimiter"
                      label-for="rowdelimiter"
                      label-cols="12"
                      label-size="sm"
                    >
                      <treeselect
                        instanceId="rowdelimiter"
                        type="text"
                        v-model="item.rowdelimiter"
                        :clearable="false"
                        :options="[
                          {
                            label: '{CR}{LF}',
                            id: '{CR}{LF}',
                          },
                        ]"
                      ></treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <b-form-group
                      label="Column Delimiter"
                      label-for="columndelimiter"
                      label-cols="12"
                      label-size="sm"
                    >
                      <treeselect
                        instanceId="columndelimiter"
                        type="text"
                        v-model="item.columndelimiter"
                        :clearable="false"
                        :options="[
                          {
                            label: 'Comma {,}',
                            id: 'Comma {,}',
                          },
                        ]"
                      ></treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-table
                      striped
                      hover
                      :items="items"
                      :fields="fields"
                      :dark="$store.state.darkMode"
                      ref="btable"
                      small
                      caption-bottom
                      show-empty
                    ></b-table>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>

        <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>

        <div class="form-actions">
          <b-button
            class="mr-2"
            v-if="currentStep > 1 && currentStep <= totalSteps"
            variant="secondary"
            @click="stepBack()"
            @keyup.enter="stepback()"
          >
            <i class="fa fa-arrow-left"></i> Prev
          </b-button>
          <b-button
            v-if="currentStep < totalSteps"
            variant="primary"
            @click="stepNext()"
            @keyup.enter="stepNext()"
          >
            Next
            <i class="fa fa-arrow-right"></i>
          </b-button>
          <!-- {{currentStep}}
          {{totalSteps}}
          {{displayStep}}-->
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "Wizard",
  data() {
    return {
      displayStep: 1,
      currentStep: 1,
      totalSteps: 2,
      item: {
        filename: null,
        locale: "English (United Kingdom)",
        unicode: false,
        codepage: "65001 (UTF-8)",
        format: "Delimited",
        textqualifier: null,
        headerdelimiter: "{CR}{LF}",
        headerrowstoskip: "0",
        columnnames: true,
        rowdelimiter: "{CR}{LF}",
        columndelimiter: "Comma {,}",
      },
      fields: [
        {
          key: "blac",
          label: "BL A/C",
          sortable: true,
          class:"text-center"
        },
        {
          key: "blentry",
          label: "BL Entry",
          sortable: true,
           class:"text-center"
        },
        {
          key: "bllineno",
          label: "BL Line No",
          sortable: true,
           class:"text-center"
        },
        {
          key: "blconjline",
          label: "BL Conj line",
          sortable: true,
           class:"text-center"
        },
      ],
      items: [
        { blac: "BCARDCONF", blentry: 1064431, bllineno: 1, blconjline: 0 },
        { blac: "BCARDCONF", blentry: 1064432, bllineno: 1, blconjline: 0 },
        { blac: "BCARDCONF", blentry: 1064433, bllineno: 1, blconjline: 0 },
      ],
    };
  },
};
</script>
